export default function () {
  if (
    document.querySelector('.ContactHelpSelect select') &&
    Array.from(document.querySelectorAll('.ContactHelpFormTab')).length > 0
  ) {
    import(
      /* webpackChunkName: "contact-help-select-module" */ './contact-help-select'
    ).then((module) => {
      const ContactHelpSelect = module.default
      ContactHelpSelect()
    })
  }
}
